<template>
    <transition name="fade">
        <div class="vue-modal" v-show="open">
            <transition name="drop-in">
                <div class="vue-modal-inner" v-show="open">
                    <div class="vue-modal-content" style="color: var(--theme-text-main);">
                        <slot />
                        <p class="h3 text-seccess fw-bold" v-if="showError">The Customer has no account</p>
                        <label title="PayCredit">Credit Amount</label>
                        <div style="display:flex">
                            <input type="text" class="form-control" name="accountAmount"
                                v-on:keyup.enter="checkBuyerAccount()" id="accountAmount" v-model="selfAccountAmount" />
                            <!-- <button @click="activeKeyboard = 1" class="btn btn-sm"
                                :class="activeKeyboard == 1 ? 'btn-primary' : 'btn-danger'">
                                <i class="fas fa-table-cells"></i>
                            </button> -->
                        </div>
                        <br>
                        <table style="width:100%">
                            <tr>
                                <td>
                                </td>
                                <td>
                                    <button class="btn btn-primary" @click="checkBuyerAccount()">Add Payment</button>
                                </td>
                                <td>
                                    <button @click="close" class="btn btn-primary">Close</button>
                                </td>
                                <td>
                                </td>
                                <td>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </transition>
                        <div class="col-sm-4"
                            style="position:fixed;width:240px;height:300px; min-height: 200px;left:0px;bottom:-80px;margin-top: 0px;margin-bottom: 0px;margin-left : 0px;color:#000000; background-color: #1a1f2f;margin-left: -15px;margin-right: -10px;">
                            <numericpad :onInput="onInput" :onDelete="onDelete" :onReset="onReset" :show="true" />
                        </div>
        </div>
    </transition>
</template>
<script>
import axios from "axios";
import commonServices from "@/shared/commonServices"
import numericpad from "@/components/SimpleKeyboard";
export default {
    mixins: [commonServices],
    name: "PayAccount",
    data: function () {
        return {
            activeKeyboard: 1,
            selfAccountAmount: '',
            customernumber: '',
            customername: '',
            customerid: '',
            showError: false,
            customer: 0,
        }
    },
    components: {
        numericpad
    },
    methods: {
        onInput(key) {
            if (this.activeKeyboard == 2) {
                if (key == 11) {
                    this.customernumber = (this.customernumber + '0')
                } else {
                    this.customernumber = (this.customernumber + key)
                }
            } else {
                if (key == 11) {
                    this.selfAccountAmount = (this.selfAccountAmount + '0')
                } else {
                    this.selfAccountAmount = (this.selfAccountAmount + key)
                }
            }



        },
        onDelete() {
            
            if (this.activeKeyboard == 2) {
                this.customernumber = this.customernumber.slice(0, this.customernumber.length - 1);
            }else{
                this.selfAccountAmount = this.selfAccountAmount.slice(0, this.selfAccountAmount.length - 1);
            }
            
        },
        onReset() {
            
            if (this.activeKeyboard == 2) {
                this.customernumber = '';
            }else{
                this.selfAccountAmount = '';
            }
        },
        passAccountAmount() {
            //this.$emit('getCustomernumber', this.customernumber)
            this.$emit('getCustomerName', this.customername)
            this.$emit('getCustomer', this.customer)
            this.$emit('getAccountAmount', this.selfAccountAmount)
            this.customernumber = '';
        },
        checkBuyerAccount: async function () {
            try {
                //Gift Card API
                let dataURL = this.apiURL + 'Customers/checkCustomerCredit';
                let accountJson = { "appId": "7", 'customernumber': this.customernumber, 'customer_id': this.customer_id };
                let response = await axios.post(dataURL, accountJson);
                if (response.data.void === true) {
                    this.customername = response.data.customername;
                    this.customerid = response.data.customerid;
                    this.customer = response.data.customerid;
                    this.passAccountAmount();
                    this.close();
                } else {
                    this.showError = true;
                    this.customername = "";
                    this.customerid = "";

                }
            }
            catch (error) {
                console.log(error);
            }
        }
    },
    props: {
        open: {
            type: Boolean,
            required: true
        },
        customer_id:{
            type: Number,
            required: false
        },
        accountAmount: {
            type: String,
            required: true
        },
    },

    mounted() {
        // this.selfAccountAmount = this.$props.accountAmount;
    },
    setup(_, { emit }) {
        const close = () => {
            emit('close');
        };

        return { close };
    },
};
</script>
<style scoped>
*,
::before::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

/* .vue-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1;
}

.vue-modal-inner {
    max-width: 50%;
    max-height: 50%;
    margin: 2rem auto;
} */

.vue-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
}

.vue-modal-inner {
    max-width: 90%;
    max-height: 90vh;
    margin: 0;
}

.vue-modal-content {
    position: relative;
    background-color: var(--form-color);
    border: 5px solid rgba(0, 0, 0, 0.3);
    background-clip: padding-box;
    border-radius: 1rem;
    padding: 1rem;
    width: 100%;
    height: 100%;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.drop-in-enter-active,
.drop-in-leave-active {
    transition: all 0.3s ease-out;
}

.drop-in-enter-from,
.drop-in-leave-to {
    opacity: 0;
    transform: translateY(50px);
}</style>
